var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBallPile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M5.5 15.197l.164.006C6.968 15.289 8 16.387 8 17.729l-.005.166c-.085 1.32-1.17 2.365-2.495 2.365-1.38 0-2.5-1.133-2.5-2.531 0-1.398 1.12-2.531 2.5-2.531zm6.5 0l.164.006c1.304.086 2.336 1.184 2.336 2.526l-.005.166c-.085 1.32-1.17 2.365-2.495 2.365-1.38 0-2.5-1.133-2.5-2.531 0-1.398 1.12-2.531 2.5-2.531zm6.5 0l.164.006c1.304.086 2.336 1.184 2.336 2.526l-.005.166c-.085 1.32-1.17 2.365-2.495 2.365-1.38 0-2.5-1.133-2.5-2.531 0-1.398 1.12-2.531 2.5-2.531zm-10-5.821l.164.005C9.968 9.467 11 10.565 11 11.907l-.005.166c-.085 1.32-1.17 2.365-2.495 2.365-1.38 0-2.5-1.133-2.5-2.531 0-1.398 1.12-2.531 2.5-2.531zm7 0l.164.005C16.968 9.467 18 10.565 18 11.907l-.005.166c-.085 1.32-1.17 2.365-2.495 2.365-1.38 0-2.5-1.133-2.5-2.531 0-1.398 1.12-2.531 2.5-2.531zM12 3.7c1.38 0 2.5 1.133 2.5 2.531 0 1.398-1.12 2.531-2.5 2.531S9.5 7.63 9.5 6.232c0-1.4 1.12-2.532 2.5-2.532z"
  }))));
}

export default SvgBallPile;